"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToType = void 0;
const isString_1 = __importDefault(require("lodash/isString"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
function objectValueSort(first, second, key, reverse = false) {
    const value1 = first[key];
    const value2 = second[key];
    if ((0, isNumber_1.default)(value1) && (0, isNumber_1.default)(value2)) {
        if (!reverse) {
            return value1 - value2;
        }
        else {
            return value2 - value1;
        }
    }
    if ((0, isString_1.default)(value1) && (0, isString_1.default)(value2)) {
        if (!reverse) {
            return value1.localeCompare(value2);
        }
        else {
            return value2.localeCompare(value1);
        }
    }
    return 0;
}
exports.default = objectValueSort;
/**
 * Converts the `second` parameter to the same type as the `first`.
 *
 * If `first` is `null` or `undefined`, converts `second` to a `boolean`.
 * A value of `'false'` will also be converted to a `boolean` value of `false`.
 * @template T
 * @template K
 * @param {T} first
 * @param {K} second
 * @returns {K} `second` converted to type of `first`
 */
function convertToType(first, second) {
    const cons = (first == null ? true : first).constructor;
    if (second === 'false') {
        return cons('');
    }
    return cons(second);
}
exports.convertToType = convertToType;
//# sourceMappingURL=utils.js.map